import classNames from 'classnames';
import { FC, ReactNode } from 'react';

export const Panel: FC<{
  children: ReactNode;
}> = ({ children }) => {
  return (
    <div className="card bg-lvl1 h-100 border-start border-top d-flex flex-column" data-e2e="blotter-panel">
      {children}
    </div>
  );
};

export const Footer: FC<{
  children: ReactNode;
  className?: string;
}> = ({ className, children }) => {
  return <div className={classNames('card-footer px-4 pb-4', className)}>{children}</div>;
};
